import React from 'react';
import { motion } from 'framer-motion';

import { founderTypes } from '../../data/founderTypes';
import { formatFounderTitle } from '../../utils/textUtils';
import {
  HistoryCard,
  HistoryList,
  HistoryRow,
  HistoryRowMeta,
  HistoryRowTitle,
  HistoryBadge,
  HistoryNameInput,
  HistoryActionRow,
  HistoryButton,
  SectionTitle,
} from '../../pages/results/resultsStyles';

const ResultsHistorySection = ({
  historyRuns,
  selectedRunId,
  onViewRun,
  onNameChange,
  onNameCommit,
  variants,
}) => {
  if (historyRuns.length === 0) return null;

  return (
    <HistoryCard as={motion.section} variants={variants} aria-labelledby="history-heading">
      <SectionTitle id="history-heading" as="h2">
        Previous runs
      </SectionTitle>
      <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '0.25rem' }}>
        Saved locally. Spot patterns and track change over time.
      </p>
      <HistoryList>
        {historyRuns.slice(0, 8).map((run, idx) => {
          const runPrimary = String(run?.profile?.primaryType || '').toLowerCase();
          const runPrimaryTitle = formatFounderTitle(founderTypes[runPrimary]?.title || runPrimary);
          const runPrimaryPct = run?.profile?.percentages?.[runPrimary] ?? 0;
          const isSelected = selectedRunId ? selectedRunId === run.id : idx === 0;
          return (
            <HistoryRow key={run.id}>
              <HistoryRowMeta>
                <HistoryRowTitle>
                  {isSelected && <HistoryBadge>Viewing</HistoryBadge>}
                  {idx === 0 && (
                    <HistoryBadge
                      style={{
                        background: 'rgba(37, 65, 178, 0.16)',
                        borderColor: 'rgba(37, 65, 178, 0.22)',
                      }}
                    >
                      Latest
                    </HistoryBadge>
                  )}
                  <span>{new Date(run.createdAt).toLocaleDateString()}</span>
                  <span style={{ color: 'rgba(255,255,255,0.72)', fontWeight: 600 }}>
                    {runPrimaryTitle} ({runPrimaryPct}%)
                  </span>
                </HistoryRowTitle>
                <HistoryNameInput
                  value={run.name || 'Untitled run'}
                  onChange={(e) => onNameChange(run.id, e.target.value)}
                  onBlur={(e) => onNameCommit(run.id, e.target.value)}
                  aria-label={`Rename run from ${new Date(run.createdAt).toLocaleDateString()}`}
                />
              </HistoryRowMeta>
              <HistoryActionRow>
                <HistoryButton
                  type="button"
                  onClick={() => onViewRun(run)}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {idx === 0 && !isSelected ? 'View latest' : 'View'}
                </HistoryButton>
              </HistoryActionRow>
            </HistoryRow>
          );
        })}
      </HistoryList>
    </HistoryCard>
  );
};

export default ResultsHistorySection;
